export const EventGuardar: string = 'EventGuardar';
export const EventCancelar: string = 'EventCancelar';
export const EventArchivar: string = 'EventArchivar';
export const EventClonar: string = 'EventClonar';
export const EventChange: string = 'EventChange';
export const EventDontSave: string = 'EventDontSave';